import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=b8f49712&scoped=true"
import script from "./ErrorNotification.vue?vue&type=script&lang=ts"
export * from "./ErrorNotification.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ErrorNotification.vue?vue&type=style&index=0&id=b8f49712&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b8f49712",
  null
  ,true
)

export default component.exports